import { render } from "./BaseTable.vue?vue&type=template&id=444ad770&scoped=true&ts=true"
import script from "./BaseTable.vue?vue&type=script&lang=ts"
export * from "./BaseTable.vue?vue&type=script&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=444ad770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444ad770"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
